import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/UserSlice';
import orderReducer from './slices/OrderSlice';
import itemReducer from './slices/ItemSlice';
import driverReducer from './slices/DriverSlice'

export const store = configureStore({
  reducer: {
    getusers: userReducer,
    getorders: orderReducer,
    getitems: itemReducer,
    getdrivers: driverReducer,
  },
});
